import { render, staticRenderFns } from "./OrganisationContracts.vue?vue&type=template&id=0773e652&"
import script from "./OrganisationContracts.vue?vue&type=script&lang=js&"
export * from "./OrganisationContracts.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationContracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports